module.exports = __webpack_public_path__ + "friend2.png?86d0156e0b5ec0fb108dc36cd98be3a0";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend2.png
// module id = 475
// module chunks = 0